import React from 'react';
import { Card, Select } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import { Vehicle } from '../../types';

const { Option } = Select;

interface FuelEfficiencyCalculatorProps {
  t: (key: string) => string;
  vehicles: Vehicle[];
  isMobile: boolean;
  onCalculateEfficiency: (vehicleId: number) => void;
}

const FuelEfficiencyCalculator: React.FC<FuelEfficiencyCalculatorProps> = ({
  t,
  vehicles,
  isMobile,
  onCalculateEfficiency
}) => {
  return (
    <Card 
      size="small" 
      style={{ marginBottom: '16px', backgroundColor: '#f0f2f5' }}
      bodyStyle={{ padding: isMobile ? '8px' : '12px' }}
    >
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        flexWrap: 'wrap',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CalculatorOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
          <span style={{ fontWeight: 'bold', fontSize: isMobile ? '12px' : '14px' }}>
            {isMobile ? 'Fuel Calculator' : t('fuel.efficiency.calculator') || 'Fuel Efficiency Calculator (GPS-based)'}:
          </span>
        </div>
        <Select
          placeholder={t('select.vehicle') || 'Select vehicle'}
          style={{ width: isMobile ? '100%' : 250 }}
          allowClear
          showSearch
          optionFilterProp="children"
          onChange={(vehicleId) => {
            if (vehicleId) {
              onCalculateEfficiency(vehicleId as number);
            }
          }}
        >
          {vehicles.map(vehicle => (
            <Option key={vehicle.id} value={vehicle.id}>
              {vehicle.licensePlate} - {vehicle.brand} {vehicle.model}
            </Option>
          ))}
        </Select>
        {!isMobile && (
          <span style={{ fontSize: '12px', color: '#666', marginLeft: '8px' }}>
            ✓ Uses GPS tracking - No odometer required
          </span>
        )}
      </div>
    </Card>
  );
};

export default FuelEfficiencyCalculator;
